import moment from "moment";
import { dateFormat, dateTimeFormat } from "./constants";

export function formateNumber(number) {
  return new Intl.NumberFormat("en-US").format(number);
}
export function formateResponse(data) {
  return data?.map((item) => ({
    ...item,
    deleteId: crypto.randomUUID(),
  }));
}

const PAYLOAD_STEPS = ["cash", "coins", "valuables", "documents"];

export function createPayload(data, step, consignments, exchangeRate) {
  const consignmentType = PAYLOAD_STEPS[step];
  data["deleteId"] = crypto.randomUUID();
  data["exchangeRate"] = exchangeRate;

  const containerObj = {
    details: data?.details,
    count: data?.count ?? 1,
    remarks: "",
    consignmentType: capitalizeFirstLetter(consignmentType),
    containerType: data?.containerType,
    containerId: data?.containerId,
    sealNo: data?.sealNo,
    localValue: data?.localValue,
    currency: () => {
      if (consignmentType === "coins") {
        return "AED";
      } else if (consignmentType === "documents") {
        return "";
      }
      return data?.currency;
    },

    declaredValue: data?.declaredValue,
    exchangeRate: consignmentType === "coins" ? 1 : data?.exchangeRate,
    deleteId: data["deleteId"],
  };

  const containers = consignments?.length
    ? [...consignments, containerObj]
    : [containerObj];
  return containers;
}

export function capitalizeFirstLetter(string) {
  return string?.[0]?.toUpperCase() + string?.slice(1);
}

export const formateUtcToLocalDateTime = (date, formate) => {
  if (formate) {
    return moment(date, formate).format(dateTimeFormat);
  }
  return moment.utc(date).local().format(dateTimeFormat);
};

export const formateUtcToLocalDate = (date, formate) => {
  if (formate) {
    return moment.utc(date, formate).local().format(dateFormat);
  }
  return moment.utc(date).local().format(dateFormat);
};

export function HasPermission(user, role, permission) {
  if (permission) {
    if (user.Permissions.includes(`${role}-${permission}`)) {
      return true;
    }
    return false;
  }
  if (user.Permissions.includes(`${role}`)) {
    return true;
  }

  return false;
}
